import React, { useEffect, useState } from 'react'
import { Link } from 'gatsby'

import { Disclosure } from '@headlessui/react'
import { MenuIcon, XIcon } from '@heroicons/react/outline'

import { FiChevronRight } from 'react-icons/fi'

// Primereact
//theme
import 'primereact/resources/themes/lara-light-indigo/theme.css'

//core
import 'primereact/resources/primereact.min.css'

import { Accordion, AccordionTab } from 'primereact/accordion'

// images
import Logo from '../assets/images/Logo/Biome_Logo.webp'

const Navbar = () => {
    const [isScrolled, setIsScrolled] = useState(false)
    const [hoverInformationen, setHoverInformationen] = useState(false)

    useEffect(() => {
        const onScroll = () => {
            if (window.pageYOffset > 0) {
                setIsScrolled(true)
            } else {
                setIsScrolled(false)
            }
        }
        // clean up code
        window.removeEventListener('scroll', onScroll)
        window.addEventListener('scroll', onScroll, { passive: true })
        return () => window.removeEventListener('scroll', onScroll)
    }, [])

    return (
        <Disclosure as="nav" className={isScrolled ? 'active' : ''}>
            {({ open }) => (
                <>
                    <div
                        className={`navBar relative z-40 mx-auto ${
                            hoverInformationen && 'bg-primary'
                        }`}
                    >
                        <div
                            className={`navigation__background ${
                                open && 'mobile-open'
                            }`}
                        ></div>
                        <div className="relative flex items-center justify-between h-16 px-2 lg:px-8">
                            <div className="absolute inset-y-0 right-0 flex items-center lg:hidden">
                                {/* Mobile menu button*/}
                                <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-gray-50 hover:text-white hover:bg-gray-700 transition-all ease-in-out duration-300 z-50 mr-4">
                                    <span className="sr-only">
                                        Open main menu
                                    </span>
                                    {open ? (
                                        <XIcon
                                            className="block h-6 w-6"
                                            aria-hidden="true"
                                        />
                                    ) : (
                                        <MenuIcon
                                            className="block h-6 w-6"
                                            aria-hidden="true"
                                        />
                                    )}
                                </Disclosure.Button>
                            </div>
                            <div className="flex-1 flex items-center justify-between content-center py-2">
                                <div className="flex-shrink-0 flex items-center justify-start relative w-24">
                                    <div className="navSun -left-7 w-32 h-32 rounded-full absolute -z-10"></div>
                                    <Link to="/">
                                        <img
                                            className="flex navSunLogo z-50 relative"
                                            src={Logo}
                                            alt="BiomeCard Logo"
                                        />
                                    </Link>
                                </div>
                                <div className="hidden lg:block lg:ml-6 ">
                                    <div className="flex md:space-x-6 lg:space-x-8 h-[64px] items-center">
                                        <Link
                                            to="/"
                                            className="nav-link text-gray-50"
                                            activeClassName="router-link-active"
                                        >
                                            Home
                                        </Link>
                                        <a
                                            aria-hidden="true"
                                            role="tab"
                                            className={`nav-link  h-full mt-8 ${
                                                hoverInformationen
                                                    ? 'text-accentPrime'
                                                    : 'text-gray-50'
                                            }`}
                                            onMouseEnter={() =>
                                                setHoverInformationen(true)
                                            }
                                            onMouseLeave={() =>
                                                setHoverInformationen(false)
                                            }
                                        >
                                            Safari{'  '}
                                            <FiChevronRight
                                                className={`inline-block mt-1 w-5 h-5 transition-all ${
                                                    hoverInformationen
                                                        ? '-rotate-90'
                                                        : 'rotate-90'
                                                }`}
                                            />
                                        </a>
                                        <Link
                                            to="/en/Stats"
                                            className="nav-link text-gray-50"
                                            activeClassName="router-link-active"
                                        >
                                            Stats
                                        </Link>
                                        <Link
                                            to="/en/About"
                                            className="nav-link text-gray-50"
                                            activeClassName="router-link-active"
                                        >
                                            About Us
                                        </Link>
                                        <Link
                                            to="/en/Contact"
                                            className="nav-link text-gray-50"
                                            activeClassName="router-link-active"
                                        >
                                            Contact
                                        </Link>
                                        {/* <a
                                            href="#"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="nav-link text-gray-50"
                                        >
                                            Shop
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Whats in the mobile Nav */}
                    <Disclosure.Panel className="lg:hidden pt-4">
                        <div className="px-2 pt-2 pb-3 mobileNav flex flex-col gap-y-5 items-center justify-center text-2xl z-50 relative">
                            <Link
                                to="/"
                                className="nav-link text-gray-50 block"
                                activeClassName="router-link-active"
                            >
                                Home
                            </Link>

                            <Accordion>
                                <AccordionTab header="Safari">
                                    <div className="accordion-body">
                                        <div className="flex flex-col justify-center items-center text-2xl font-medium tracking-tight text-gray-50">
                                            <h2>
                                                <i>Season 1</i>
                                            </h2>
                                        </div>

                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 text-center mx-auto mt-4 text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-gray-50">
                                            <Link
                                                to="/en/Safari/S1/Animals"
                                                className="s1_animal imageButton relative"
                                            >
                                                <div className="imageButton_overlay absolute top-0 left-0 z-40"></div>
                                                <div className="relative z-50">
                                                    <h3>Animals</h3>
                                                </div>
                                            </Link>
                                            <Link
                                                to="/en/Safari/S1/Biomes"
                                                className="s1_biome imageButton relative"
                                            >
                                                <div className="imageButton_overlay absolute top-0 left-0 z-40"></div>
                                                <div className="relative z-50">
                                                    <h3>Biomes</h3>
                                                </div>
                                            </Link>
                                            <Link
                                                to="/en/Safari/S1/Items"
                                                className="s1_item imageButton relative"
                                            >
                                                <div className="imageButton_overlay absolute top-0 left-0 z-40"></div>
                                                <div className="relative z-50">
                                                    <h3>Items</h3>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </AccordionTab>
                            </Accordion>
                            <Link
                                to="/en/Stats"
                                className="nav-link text-gray-50 block"
                                activeClassName="router-link-active"
                            >
                                Stats
                            </Link>
                            <Link
                                to="/en/About"
                                className="nav-link text-gray-50 block"
                                activeClassName="router-link-active"
                            >
                                About US
                            </Link>
                            <Link
                                to="/en/Contact"
                                className="nav-link text-gray-50 block"
                                activeClassName="router-link-active"
                            >
                                Contact
                            </Link>
                            {/* <a
                                href="#"
                                rel="noopener noreferrer"
                                target="_blank"
                                className="nav-link text-gray-50 block"
                            >
                                Shop
                            </a> */}
                        </div>
                    </Disclosure.Panel>

                    {/* MEGA Menu - Safari */}

                    {hoverInformationen && (
                        <>
                            <div className="h-screen w-screen z-10 bg-black opacity-50 ease-in-out transition-all duration-500"></div>
                            <div
                                onMouseEnter={() => setHoverInformationen(true)}
                                onMouseLeave={() =>
                                    setHoverInformationen(false)
                                }
                                className="fixed top-[64px] left-0 w-full px-10 pt-8 pb-16 bg-primary text-gray-50 shadow-2xl z-20"
                            >
                                <div className="flex flex-col justify-center items-center text-5xl font-bold tracking-tight text-accentPrime">
                                    <h2>Season 1</h2>
                                </div>

                                <div className="grid grid-cols-3 gap-10 text-center mx-auto mt-10 text-4xl font-bold tracking-tight">
                                    <Link
                                        to="/en/Safari/S1/Animals"
                                        className="s1_animal imageButton relative"
                                    >
                                        <div className="imageButton_overlay absolute top-0 left-0 z-40"></div>
                                        <div className="relative z-50">
                                            <h3>Animals</h3>
                                        </div>
                                    </Link>
                                    <Link
                                        to="/en/Safari/S1/Biomes"
                                        className="s1_biome imageButton relative"
                                    >
                                        <div className="imageButton_overlay absolute top-0 left-0 z-40"></div>
                                        <div className="relative z-50">
                                            <h3>Biomes</h3>
                                        </div>
                                    </Link>
                                    <Link
                                        to="/en/Safari/S1/Items"
                                        className="s1_item imageButton relative"
                                    >
                                        <div className="imageButton_overlay absolute top-0 left-0 z-40"></div>
                                        <div className="relative z-50">
                                            <h3>Items</h3>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </>
                    )}
                </>
            )}
        </Disclosure>
    )
}

export default Navbar
